module.exports = __webpack_public_path__ + "static/ibm-plex-serif-v8-latin-regular-7261ee2cbee34a8491898940e0af500d.woff2";